import React, { Component } from 'react';
import { ComboBox } from 'carbon-components-react';
import PropTypes from 'prop-types';

export default class AuditWorkSiteComboBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.items
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange = (selectedItem) => {
    const item = selectedItem ? selectedItem.selectedItem : null;
    this.props.onChange(item);
  };

  render() {
    return (
      <ComboBox
        id="comboBoxWorkSite"
        disabled={this.state.items < 1 || this.props.disabled}
        placeholder="Choose a WorkSite"
        items={this.state.items}
        onChange={this.onChange}
        invalid={this.props.invalid}
        invalidText={this.props.invalidText}
        itemToString={(item) => (item ? item && item.name : '')}
        selectedItem={this.props.selectedItem}
      />
    );
  }
}

AuditWorkSiteComboBox.propTypes = {
  invalid: PropTypes.bool,
  invalidText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  selectedItem: PropTypes.object,
  disabled: PropTypes.bool
};
AuditWorkSiteComboBox.defaultProps = {
  invalid: false,
  invalidText: '',
  selectedItem: null,
  disabled: true
};
